import type { Issue, IssueScope, ProviderId } from '../../api/types';
import { useIssueSearch } from './useIssueSearch';
import { IssuePickerSelection } from './IssuePickerSelection';
import { IssueSearchDialog } from './IssueSearchDialog';

export interface IssuePickerProps {
  /** SCM/Board provider id (e.g. 'azure-devops', 'github', 'jira'). */
  provider: ProviderId | 'jira';
  /** Scope passed to every search call. Required for Azure (project). */
  scope: IssueScope;
  /** Currently selected issue (controlled). */
  selected: Issue | null;
  onSelect: (issue: Issue | null) => void;
  /** Whether to render rich provider-specific extras (Azure description etc.). */
  richMode?: boolean;
  disabled?: boolean;
}

export function IssuePicker(props: IssuePickerProps): JSX.Element {
  const search = useIssueSearch(props);
  const select = (issue: Issue) => {
    props.onSelect(issue);
    search.setOpen(false);
  };
  return (
    <>
      <IssuePickerSelection {...props} onOpen={() => search.setOpen(true)} />
      <IssueSearchDialog search={search} onSelect={select} />
    </>
  );
}
